var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7501 12.7498C17.9365 12.9356 18.0845 13.1564 18.1854 13.3995C18.2864 13.6426 18.3383 13.9033 18.3383 14.1665C18.3383 14.4297 18.2864 14.6904 18.1854 14.9335C18.0845 15.1766 17.9365 15.3974 17.7501 15.5832L15.5834 17.7498C15.3976 17.9363 15.1768 18.0842 14.9337 18.1852C14.6906 18.2861 14.43 18.3381 14.1667 18.3381C13.9035 18.3381 13.6429 18.2861 13.3998 18.1852C13.1567 18.0842 12.9359 17.9363 12.7501 17.7498L2.25008 7.24983C1.87554 6.87348 1.66528 6.36413 1.66528 5.83317C1.66528 5.30221 1.87554 4.79285 2.25008 4.4165L4.41675 2.24984C4.7931 1.8753 5.30245 1.66504 5.83341 1.66504C6.36437 1.66504 6.87373 1.8753 7.25008 2.24984L17.7501 12.7498Z",
    stroke: "#143B6B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 10.4167L13.7499 8.75",
    stroke: "#143B6B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58325 7.91667L11.2499 6.25",
    stroke: "#143B6B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08325 5.41667L8.74992 3.75",
    stroke: "#143B6B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 12.9167L16.2499 11.25",
    stroke: "#143B6B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleIcon);
export default __webpack_public_path__ + "static/media/scale-icon.ae174eece92d528bdab1066640e9099c.svg";
export { ForwardRef as ReactComponent };